module.exports = __webpack_public_path__ + "img/sidebar-edc.167c468b.svg";